import React from "react";
import ExamScheduleView from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleView";
import Attendance from "../pages/student/attendance/Attendance";
import LeaveList from "../pages/parent/LeaveList";
import LeaveCreate from "../pages/parent/LeaveCreate";
import HolidayList from "../pages/schoolCockpit/master/holiday/HolidayList";
import UserDashboardResolver from "./UserDashboardResolver";
import GroupCockpitProfile from "../pages/groupCockpit/GroupCockpitProfile";
import MessagingEmail from "../pages/groupCockpit/message/MessagingEmail";
import ChangePassword from "../pages/groupCockpit/ChangePassword";
import ExamResult from "../pages/schoolCockpit/exam/examResult/ExamResult";
import CalendarList from "../pages/schoolCockpit/events/CalendarList";
import ViewAllAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAllAnnouncement";
import AiDashboard from "../pages/student/aidashboard/AiDashboard";
import PayFees from "../pages/parent/feesManagement/PayFees";
import PayFeesList from "../pages/parent/feesManagement/PayFeesList";

// Export routes as configuration array
export const parentRoutes = [
  // Dashboard
  { path: "dashboard", element: <UserDashboardResolver /> },

  // Profile
  { path: "profile", element: <GroupCockpitProfile /> },
  { path: "change-password", element: <ChangePassword /> },

  { path: "leave", element: <LeaveList /> },
  { path: "leaveCreate", element: <LeaveCreate /> },

  // announcement
  { path: "ViewAllAnnouncement", element: <ViewAllAnnouncement /> },

  // Attendance
  { path: "attendance", element: <Attendance /> },

  // Exams Routes
  { path: "examTimeTable", element: <ExamScheduleView /> },
  { path: "exams/results", element: <ExamResult /> },

  //Holiday
  { path: "holidayList", element: <HolidayList /> },

  // Messaging Routes
  { path: "messaging/email", element: <MessagingEmail /> },

  // Events
  { path: "events", element: <CalendarList /> },

  //  AI Dashboard
  { path: "ai-dashboard", element: <AiDashboard /> },

  // Fees Type
  { path: "payfeesList", element: <PayFeesList /> },
  { path: "payfees", element: <PayFees /> },
];

export default parentRoutes;
